import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import {
  createFlexContainer,
  createFlexMessageTemplate,
  createOpenGameAction,
} from './utils';
import { getPetAssetKey, speciesChatbot } from './species';
import { buildSender } from '../sender';

/**
 * Assets for buddies chatbot messages
 */
export const buddiesAssets = {
  'background/buddies_en': 'private/chatbot/buddies/bg_en.png',
  'background/buddies_ja': 'private/chatbot/buddies/bg_ja.png',
  'background/buddies_nudge_en': 'private/chatbot/buddies/nudge_en.png',
  'background/buddies_nudge_ja': 'private/chatbot/buddies/nudge_ja.png',
  'buddies/invite_01_ja': 'private/chatbot/buddies/invite_01_ja.png',
  'buddies/invite_02_ja': 'private/chatbot/buddies/invite_02_ja.png',
  'buddies/invite_03_ja': 'private/chatbot/buddies/invite_03_ja.png',
  'buddies/invite_04_ja': 'private/chatbot/buddies/invite_04_ja.png',
  'buddies/invite_01_en': 'private/chatbot/buddies/invite_01_en.png',
  'buddies/invite_02_en': 'private/chatbot/buddies/invite_02_en.png',
  'buddies/invite_03_en': 'private/chatbot/buddies/invite_03_en.png',
  'buddies/invite_04_en': 'private/chatbot/buddies/invite_04_en.png',
};

/**
 * Coop buddies invitation message.
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const buddiesInvitation = createFlexMessageTemplate(
  SB.object({
    locale: SB.tuple(['en', 'ja']),
    petName: SB.string(),
    species: SB.tuple(speciesChatbot),
  }),
  (data, payload, api) => {
    const text = getLocaleConfig(data.locale).buddies.invitation.text;

    const template = createFlexContainer(text, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(text, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        paddingAll: '0px',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath(`background/buddies_${data.locale}`),
            size: 'full',
            aspectMode: 'cover',
            gravity: 'center',
            aspectRatio: '1:1',
          },
          {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: api.getAssetPath(`button/playnow_${data.locale}`),
                position: 'relative',
                size: '200px',
                offsetBottom: '-55px',
              },
            ],
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
          },
        ],
      },
    });

    // Add sender to message
    template['sender'] = buildSender({
      name: data.petName,
      iconUrl: api.getAssetPath(getPetAssetKey(data.species)),
    });

    return template;
  },
);

/**
 * Nudge reminder message sent to inactive party members.
 */
export const buddiesNudge = createFlexMessageTemplate(
  SB.object({
    senderName: SB.string(),
    senderPhoto: SB.string(),
    locale: SB.tuple(['en', 'ja']),
  }),
  (data, payload, api) => {
    const text = getLocaleConfig(data.locale).buddies.nudge.title;

    const template = createFlexContainer(text, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(text, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        paddingAll: '0px',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath(`background/buddies_nudge_${data.locale}`),
            size: 'full',
            aspectMode: 'cover',
            gravity: 'center',
            aspectRatio: '1:1',
          },
          {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: api.getAssetPath(`button/playnow_${data.locale}`),
                position: 'relative',
                size: '200px',
                offsetBottom: '-55px',
              },
            ],
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
          },
        ],
      },
    });

    template['sender'] = buildSender({
      name: data.senderName,
      iconUrl: data.senderPhoto,
    });

    return template;
  },
);
